// The home's latest recording (the Accelerator critique's member 5, 20 Oct; undrawn): in place of the board's
// Recordings section, which repeated the Recordings page on the home, 1 row for the newest recording of their group
// that's open to them, as the Recordings page draws it (its date tile, or its 16:9 frame once the group has a
// thumbnail: decision 47), with its length, Watched, its tags (at most 3 on a phone, where they're only a hint) and
// Watch, and All recordings, which opens the Recordings page with its search, topics and Ask about this. It reads the
// product's rows (useProductData) and the shared rules of src/product/tagged.js, and leaves the shared
// TaggedRecordings as it is.
//
//   <LatestRecording product={productRow} />
import { Link } from '../../lib/router.jsx'
import { usePhone } from '../../lib/media.js'
import { useProductData } from '../../product/ProductData.jsx'
import { taggedRows } from '../../product/tagged.js'
import { RecordingThumb, useRecordingThumbs } from '../../product/RecordingThumb.jsx'
import { Tick } from '../../product/Icons.jsx'
import { COPY } from './copy.js'
import '../../styles/tagged.css'

const PHONE_TAGS = 3

function PlayIcon() {
  return <svg className="icon-fill" width="13" height="13" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z" /></svg>
}

export function LatestRecording({ product }) {
  const { data } = useProductData()
  const phone = usePhone()
  const p = data?.product || product
  const row = taggedRows(data, p)[0] || null
  const thumbs = useRecordingThumbs(row ? [row.thumb] : [])
  const tags = row ? (phone ? row.tags.slice(0, PHONE_TAGS) : row.tags) : []

  return (
    <section className="tg acc-latest" aria-labelledby="acc-latest-h">
      <div className="acc-latest-head">
        <h2 className="tg-h" id="acc-latest-h">{COPY.latestRecording}</h2>
        <Link className="acc-btn-line acc-btn--small acc-latest-all" to={`${p.path || ''}/recordings`}>{COPY.allRecordings}</Link>
      </div>
      {!row && <p className="tg-none">No recordings here yet.</p>}
      {row && (
        <div className="tg-row">
          <div className={row.thumb ? 'tg-row-main tg-row-main--thumb' : 'tg-row-main'}>
            {row.thumb && <RecordingThumb card={row.thumb} thumbs={thumbs} className="tg-thumb" />}
            {!row.thumb && row.block && (
              <span className="tg-date" aria-hidden="true"><span>{row.block.dow}</span><strong>{row.block.day}</strong><span>{row.block.mon}</span></span>
            )}
            <div className="tg-text">
              <div className="tg-title-line">
                <span className="tg-title">{row.title}</span>
                {row.length && <span className="tg-length">{row.length}</span>}
                {row.thumb?.item && row.day && <span className="tg-length tg-day">{row.day}</span>}
                {row.watched && <span className="tg-watched"><Tick />Watched</span>}
              </div>
              {tags.length > 0 && (
                <div className="tg-tags">
                  {tags.map(t => <span key={t.name} className="tg-tag">{t.name}</span>)}
                </div>
              )}
            </div>
            {row.href && (
              <span className="tg-actions">
                <Link className="tg-watch" to={row.href} aria-label={`${COPY.watch} ${row.title}`}><PlayIcon />{COPY.watch}</Link>
              </span>
            )}
          </div>
        </div>
      )}
    </section>
  )
}
